import { api } from '@/lib/api/client'
import type {
  Notification,
  NotificationFilter,
  NotificationResponse,
  NotificationsPage,
} from '@/features/notifications/types/notification'

interface NotificationsPageResponse {
  data: NotificationResponse[]
  meta: { pagination: { current_page: number; last_page: number } }
}

export function toNotification(notification: NotificationResponse): Notification {
  return {
    id: notification.id,
    workspaceId: notification.workspace_id,
    type: notification.type,
    severity: notification.severity,
    title: notification.title,
    body: notification.body,
    route: notification.route,
    readAt: notification.read_at,
    createdAt: notification.created_at,
  }
}

/** Maps a filter onto the endpoint's `unread` / `severity` query parameters. */
function toFilterParams(filter: NotificationFilter): Record<string, string | number> {
  if (filter === 'all') return {}
  if (filter === 'unread') return { unread: 1 }
  return { severity: filter }
}

/** `GET /notifications` returns one page of the caller's notifications, newest first. */
export async function getNotifications(
  page = 1,
  filter: NotificationFilter = 'all',
): Promise<NotificationsPage> {
  const { data } = await api.get<NotificationsPageResponse>('/notifications', {
    params: { page, ...toFilterParams(filter) },
  })

  return {
    notifications: data.data.map(toNotification),
    currentPage: data.meta.pagination.current_page,
    lastPage: data.meta.pagination.last_page,
  }
}
